export default __webpack_public_path__ + "images/VJC.1a48398.png";